import { Button } from '@mui/material';
import { useAtomValue } from 'jotai';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskAction } from '@kheops/graphql';
import useOpenable from '../../../hooks/useOpenable';
import { orderAtom } from '../../state/state';
import useOrderActions from '../../../hooks/useOrderActions';
import ConfirmDialog from '../../../common/components/ConfirmDialog';

interface OrderPaymentDisputeButton {
  action: TaskAction.Approve | TaskAction.Reject;
}
export default function OrderPaymentDisputeButton({ action }: OrderPaymentDisputeButton): React.JSX.Element {
  const { t } = useTranslation(['order', 'common']);
  const order = useAtomValue(orderAtom);
  const { updateOrder, isLoading } = useOrderActions({ orderReferenceId: order.reference_id, orderId: order.id });
  const { open, isOpen, close } = useOpenable();

  const handleClose = useCallback((confirmed: boolean) => {
    if (confirmed) {
      updateOrder(TaskAction.Reject);
    }

    close();
  }, [updateOrder]);

  const handleClick = (): void => {
    if (action === TaskAction.Approve) {
      updateOrder(action)
    } else {
      // in case of deny payment, open dialog
      open()
    }
  }

  return (
    <>
      <ConfirmDialog
        cancelLabel={t('common:cancel')}
        confirmLabel={t('order:deny_payment')}
        title={t('order:you_have_not_being_paid')}
        subTitle={t('order:deny_payment_description')}
        open={isOpen}
        onClose={handleClose}
      />
      <Button
        variant={action === TaskAction.Approve ? 'contained' : 'outlined'}
        color={action === TaskAction.Approve ? 'error' : 'tertiary'}
        onClick={handleClick}
        loading={isLoading}
      >
        {action === TaskAction.Approve ? t('order:set_as_paid') : t('order:deny_payment')}
      </Button>
    </>
  );
}
